<template>
  <!-- featured list -->
    <div class="featured-container" v-if="featureRegistrations.length">
        <!-- heading for featured -->
        <div class="featured-heading px-05" v-if="featureRegistrations.length">
            <h2>Featured</h2>
        </div>
          <VueSlickCarousel class="mr-10" v-if="featureRegistrations.length" ref="carousel" v-bind="settings">
            <div  v-for="(localRegistration,index) in featureRegistrations"  :key="index">
              <div class="registration-card-container mx-05">
                <div class="card-content">
                  <div class="logo-container">
                    <div class="logo-wrapper">
                      <img :src="getRegoLogo(localRegistration)" alt="Organization Logo" />
                    </div>
                  </div>
                  <div class="event-title">
                    {{ localRegistration.name }}
                  </div>
                  <div class="organization-name">
                    {{ localRegistration.orgtree[localRegistration.entityType].name }}
                  </div>
                  <div class="event-duration">
                    {{ dateFormatter(localRegistration.startDate) }} - {{ dateFormatter(localRegistration.endDate) }}
                  </div>
                </div>
                <div class="card-footer">
                  <el-button
                    class="register-button"
                    @click="openProductListModal(localRegistration)"
                  >
                    Register
                  </el-button>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
          <!-- Sticky Header for Mobile -->
          <div
            v-if="productListModal && selectedRego && windowWidth <= 1024"
            :class="{
              'sticky-event-header': true,
              'sticky-visible': showStickyHeader,
              'sticky-hidden': !showStickyHeader
            }"
          >
            <div class="sticky-header-content">
              <div class="sticky-event-info">
                <div class="sticky-avatar">
                  <el-avatar size="small">
                    <img :src="getRegoLogo(selectedRego)" />
                  </el-avatar>
                </div>
                <div class="sticky-details">
                  <div class="sticky-title">{{ selectedRego.name }}</div>
                  <div class="sticky-subtitle">{{ selectedRego.orgtree[selectedRego.entityType].name }}</div>
                </div>
              </div>
              <div class="sticky-actions">
                <el-button size="mini" type="text" @click="productListModal = false">
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </div>
          </div>

          <!-- dialog for the product list -->
          <el-dialog
  v-if="selectedRego"
  :append-to-body="true"
  :visible.sync="productListModal"
  :destroy-on-close="true"
  :modal-append-to-body="false"
  width="90%"
  custom-class="full-width-dialog"
>
          <registration-card
          :registration="selectedRego"
          v-if="selectedRego.type==='addon'"
           @joinWaitList="joinWaitList"
           @register="startRegistration"
           @inOpenBulkRego="handleOpenBulkRego"
           :key="key"
           :selectedMember="member"
           :members="memberList"
           @searchByTag="searchByTag" />
          </el-dialog>

          <el-dialog v-if="showTeamSelect" title="Select Team" :visible.sync="showTeamSelect">
      <div class="break-word">Please select or search for your team from the list to register </div>
      <div class="search-bar-team">
        <el-input class="input-field" placeholder="Search by team name or ID" v-model="teamKeyword"
          @keyup.enter.native="searchTeam">
          <!-- <div slot="prefix" class="d-flex align-items-center mr-20" style="cursor:pointer; height:100%; padding: 0.35rem;" @click="search">
                  <i class="el-icon-search"></i>
                </div> -->
          <el-button slot="suffix" icon="el-icon-search" size="small" @click="searchTeam">
          </el-button>
        </el-input>
      </div>
      <div class="add-new-team">
        <!-- add a line say "Can't find your team? Add a new team" -->
        <div class="mt-10">
          Can’t find your team on this list? Try searching for it.
          <!-- <span>
            <el-button class="register-button" type="text" size="medium" @click="createNewTeam()">
              Create a new team</el-button>
          </span> -->
        </div>

      </div>
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <el-table class="item-table " :border="true" highlight-current-row stripe max-height="500"
        :data="allTeams">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- display in legend style -->
            <fieldset>
              <legend>Team Details</legend>
              <div class="break-word">
                {{getOrgtree(props.row) }}
              </div>
              <div>
                Created At: {{moment(props.row.createdAt).format('DD/MM/YYYY')}}
              </div>
              <div>
                Created By: {{get(props, 'row.createdBy[0].profile.firstName','N/A')}}
                {{get(props, 'row.createdBy[0].profile.lastName')}}
              </div>
            </fieldset>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" min-width="300">
        </el-table-column>
        <!-- column to indicate your team -->
        <el-table-column prop="isMyTeam" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isMyTeam">
              Your Team
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Operation" width="120">
          <template slot-scope="scope">
            <el-button class="register-button" type="select" size="mini"
              @click="registerTeam(scope.row)" :disabled="checkTeamRegistered(scope.row)">{{ checkTeamRegistered(scope.row)? 'Registered': 'Register' }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer d-flex gap-1">
        <!-- button to create a new team -->
        <el-button class="register-button" type="select" size="medium" @click="createNewTeam()">Create new team</el-button>
        <el-button @click="showTeamSelect = false" size="medium" >Cancel</el-button>
      </span>

    </el-dialog>
    <el-dialog v-if="showEntitySelect" title="Select Entity" :visible.sync="showEntitySelect">
      <div class="break-word">Please select or search for your entity from the list to register </div>
      <div class="search-bar-team">
        <el-input class="input-field" placeholder="Search by entity name or ID" v-model="teamKeyword"
          @keyup.enter.native="searchEntity">
          <!-- <div slot="prefix" class="d-flex align-items-center mr-20" style="cursor:pointer; height:100%; padding: 0.35rem;" @click="search">
                  <i class="el-icon-search"></i>
                </div> -->
          <el-button slot="suffix" icon="el-icon-search" size="small" @click="searchEntity">
          </el-button>
        </el-input>
      </div>
      <div class="add-new-team">
        <!-- add a line say "Can't find your team? Add a new team" -->
        <div class="mt-10">
          Can’t find your entity on this list? Try searching for it. Or
          <span>
            <el-button class="register-button" type="text" size="medium" @click="createNewEntity()">
              Create a new entity</el-button>
          </span>
        </div>

      </div>
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <el-table class="item-table " :border="true" highlight-current-row stripe max-height="500"
        :data="allEntities">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- display in legend style -->
            <fieldset>
              <legend>Entities Details</legend>
              <div class="break-word">
                {{getOrgtree(props.row) }}
              </div>
              <div>
                Created At: {{moment(props.row.createdAt).format('DD/MM/YYYY')}}
              </div>
              <div>
                Created By: {{get(props, 'row.createdBy[0].profile.firstName','N/A')}}
                {{get(props, 'row.createdBy[0].profile.lastName')}}
              </div>
            </fieldset>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" min-width="300">
        </el-table-column>
        <!-- column to indicate your team -->
        <el-table-column prop="isMyTeam" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isMyTeam">
              Your Entity
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Operation" width="110">
          <template slot-scope="scope">
            <el-button class="register-button" type="select" size="mini"
              @click="registerEntity(scope.row)">Register</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamSelect = false">Cancel</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="showTeamSelectIndvToTeam" title="Select Team"
      :visible.sync="showTeamSelectIndvToTeam">
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <!-- <el-table class="item-table "  :border="true" highlight-current-row stripe max-height="500" :data="filteredTeams(tempProduct)" >
          <el-table-column
            prop="name"
            label="Name"
            min-width="300">
          </el-table-column>
          <el-table-column fixed="right" label="Operation" width="110" >
            <template slot-scope="scope">
              <el-button class="register-button" type="select"  size="mini" @click="handleTeamSelectedMethod(scope.row)">Select</el-button>
            </template>
          </el-table-column>
        </el-table> -->
      <!-- change from table above to  div contains el-card -->
      <div class="team-selector" v-for="team in filteredTeams(tempProduct)" :key="team._id">
        <el-card class="mb-10">
          <div class="d-flex gap-1 justify-content-between align-items-center p-10 ">
            <div class="team-selector-container">
              <div class="team-selector-name">
                {{ team.name }}
              </div>
            </div>
            <div class="team-selector-button">
              <el-button class="register-button" type="select" size="mini"
                @click="handleTeamSelectedMethod(team)">Select</el-button>
            </div>
          </div>
        </el-card>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamSelectIndvToTeam = false">Cancel</el-button>
      </span>

    </el-dialog>
    <el-dialog
      v-if="requireAccreditationDialog"
      title="Accreditation Required"
      :visible.sync="requireAccreditationDialog"
      width="30%"
      >
      <div class="break-word
      ">To register for  {{selectedRego.name | cap}}, Participants must first have one of the following accreditations:</div>
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <div class="d-flex gap-10 flex-wrap mt-10 " >
            <div v-for="accreditation in selectedRego.products[0].accreditationProductsRequired" :key="accreditation._id">
              <el-tag class="membership-type" >

                {{get(accreditation,'name', '') | cap}}
              </el-tag>
            </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="requireAccreditationDialog = false">Cancel</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import moment from 'moment';
import { calculateMemberAge } from '@/utils/helpers';
import _ from 'lodash';
import registrationCard from '../../views/registration/components/registration-card.vue';

export default {
  name: 'FeatureList',
  components: {
    registrationCard,
    VueSlickCarousel,
  },
  data() {
    return {
      get: _.get,
      memberMembership: [],
      memberId: undefined,
      productListModal: false,
      selectedRego: undefined,
      defaultRegoLogo: process.env.VUE_APP_LOGO,
      key: 0,
      windowWidth: window.innerWidth,
      featureRegistrations: [],
      activeTabNames: [],
      isAllExpanded: false,
      tempProduct: {},
      showTeamSelectIndvToTeam: false,
      requireAccreditationDialog: false,
      selectedProductArr: [],
      selectedEntity: {},
      teamKeyword: '',
      allTeams: [],
      formattedRego: undefined,
      showTeamSelect: false,
      showEntitySelect: false,
      allEntities: [],
      member: {},
      members: [],
      notFetching: false,
      showStickyHeader: false,
      scrollTimeout: null,
    };
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    responsiveCol() {
      return {
        xs: 24, sm: 12, md: 8, lg: 8
      };
    },
    groupedByRegistrationType() {
      const { product } = this.selectedRego;
      console.log('productBFS', product);
      const grouped = _.groupBy(product, (r) => r.type);
      return Object.keys(grouped).map((key) => {
        console.log({ key });
        let header;
        switch (key) {
          case 'indv-to-team':
            header = 'Join a Team';
            break;
          case 'team':
            header = 'Register A Team';
            break;
          case 'indv':
            header = 'Become a Member';
            break;
          default:
            header = 'Other';
        }
        return {
          key,
          header,
          products: grouped[key],
        };
      });
    },
    settings() {
      return {
        dots: true,
        edgeFriction: 0.35,
        arrows: false,
        infinite: true,
        speed: 1000,
        pauseOnDotsHover: true,
        // fade: true,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: Math.min(this.featureRegistrations.length, 3),
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              infinite: true,
              initialSlide: 2,
              autoplay: true,
              autoplaySpeed: 5000,
              speed: 500,
              slidesToShow: 2,
              slidesToScroll: 1,
              swipeToSlide: true
            }
          },
          // {
          //   breakpoint: 600,
          //   settings: {
          //     dots: true,
          //     infinite: true,
          //     initialSlide: 2,
          //     speed: 500,
          //     autoplay: true,
          //     autoplaySpeed: 5000,
          //     slidesToShow: Math.min(this.featureRegistrations.length, 1),
          //     slidesToScroll: 2,
          //     swipeToSlide: true
          //   }
          // },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 500,
              dots: true,
              swipe: true,
              arrows: false,

            }
          }
        ]
      };
    },
  },
  async created() {
    let customEntity = {};
    console.log('Creating Feature List');
    // console.log({
    //   memberId: this.memberId
    // });
    await this.getMemberList();

    if (!this.memberId) {
      let activeMember = this.$store.getters['user/activeMember'];
      // console.log({
      //   activeMember,
      //   activeMemberIsEmpty: _.isEmpty(activeMember)
      // });
      if (_.isEmpty(activeMember)) {
        await this.fetchMembers();
        activeMember = this.$store.getters['user/activeMember'];
        // console.log({
        //   activeMember2: activeMember
        // });
      }
      if (activeMember && activeMember._id) {
        this.memberId = activeMember._id;
      }
      // this.memberId = activeMember._id;
    }
    console.log('this.memberId', this.memberId);
    const foundEntity = this.$store.getters['national/getEntity'];
    if (this.memberId) {
      const response = await this.getMemberMembership(this.memberId);
      this.memberMembership = response.data.data;
      this.$store.commit('user/setMemberRegos', this.memberMembership);
    }
    console.log('foundEntity', foundEntity);
    if (foundEntity && foundEntity._id && foundEntity.name !== '') {
      console.log('hasfoundEntity', foundEntity);
      customEntity = {
        _id: foundEntity._id,
        name: foundEntity.name,
        level: foundEntity.level
      };
    }
    this.$store.commit('loading', true, 'Loading member...');
    if (this.memberId) {
      // this.memberId = this.personalise.memberId;
      // this.$store.commit('loadingText', 'Loading member...');
      Promise.all([
        this.$http.get(`/assemble/api/v1/account/portal/members/${this.memberId}`),
      ])
        .then(([resMember]) => {
          this.member = resMember.data.data;
        }).catch((error) => {
          this.$message.error(error.response.data.message);
        });
    }
    // this.$store.commit('loadingText', 'Loading member...');
    const resFeatured = await this.$http.post('/assemble/api/v1/portal/entity/featured',
      { customEntity });
    this.featureRegistrations = resFeatured.data.data;
    console.log('this.featureRegistrations', this.featureRegistrations);
    this.$store.commit('cart/setTransactionFee', resFeatured.data.transactionFee);
    this.key += 1;
    this.$store.commit('loading', false);

    // listen to the event resize
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    handleOpenBulkRego(value) {
      console.log('bulk rego dialog open', value);
      this.notFetching = value;
    },
    async getMemberList() {
      try {
        const response = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
        this.memberList = response.data.data;

        const activeMember = this.$store.getters['user/activeMember'];

        if (!this.memberId) {
          if (activeMember && activeMember._id) {
            // Prioritize the active member from the store
            this.memberId = activeMember._id;
          } else if (this.memberList.length > 0) {
            // Fall back to the first member in the list
            this.memberId = this.memberList[0]._id;

            // Optionally set the first member as active in the store
            this.$store.commit('user/setActiveMember', this.memberList[0]);
          }
        }
        if (this.memberId && !this.memberList.some((member) => member._id === this.memberId)) {
          this.memberId = this.memberList.length > 0 ? this.memberList[0]._id : null;
        }
      } catch (error) {
        console.error('Error fetching member list:', error);
        this.$message.error('Failed to fetch member list. Please try again.');
      }
    },
    async joinWaitList(productId, eventId, entityType) {
      console.log('joind waitlist');
      this.$store.commit('loading', { loading: true, text: 'Joining waitlist...' });
      this.$http.post('/assemble/api/v1/portal/waitlist', {
        eventId,
        entityId: eventId,
        type: entityType,
        memberId: this.memberId,
        productId
      }).then((res) => {
        this.$store.commit('loading', false);
        this.$message.success(res.data.message);
      }).catch((e) => {
        this.$store.commit('loading', false);
        this.$message.error(e.response.data.message);
      });
    },
    async fetchMembers() {
      console.log('Fecthing Members in Feature List');
      const resMember = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
      let selectedMember;
      if (resMember.data) {
        this.members = resMember.data.data;
        // add selected property to each member
        this.members.forEach((member) => {
          if (member.mainProfile) {
            this.$store.commit('user/setActiveMember', member);
          }
        });
        // console.log({
        //   members
        // });
      }

      if (!selectedMember) {
        [selectedMember] = this.members;
        this.$store.commit('user/setActiveMember', selectedMember);
      }
      console.log({
        selectedMember
      });
    },
    formatDuration(registration) {
      const year = _.get(registration, 'durationYear', 0);
      const month = _.get(registration, 'durationMonth', 0);
      const day = _.get(registration, 'durationDay', 0);
      const startDate = moment(Date.now());
      if (startDate) {
        const momentStartAdd = moment(startDate).add(year, 'years').add(month, 'months').add(day, 'days');
        const formatted = momentStartAdd.format('DD MMM YYYY');
        return `${this.dateFormatter(startDate)} - ${this.dateFormatter(formatted)}`;
      }
      return '';
    },
    formatExpiry(expiry) {
      if (expiry) {
        return `Expires at ${this.dateFormatter(expiry)}`;
      }
      return '';
    },
    formatStartDate(startDate, endDate) {
      if (_.isEmpty(startDate)) {
        return '';
      }
      if (endDate) {
        return this.dateFormatter(startDate);
      }
      return `Starts ${this.dateFormatter(startDate)}`;
    },
    formatEndDate(endDate) {
      if (endDate) {
        return `- ${this.dateFormatter(endDate)}`;
      }
      return '';
    },
    getButtonLabel(product) {
      console.log('product', product);
      const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullTeamSlot = this.checkFullSlot(product);
      // console.log('canJoinWaitingList', product.isWaitlistOpen, !isRegistered, !isNotEligible, product.isRegoOpen);
      // const canJoinWaitingList = this.checkIsWaitlistOpen(product);

      if (isRegistered && !isPayAfter) {
        return 'Already Registered';
      }
      if (!isEligible) {
        return 'Ineligible';
      }
      if (fullTeamSlot) {
        return 'Full';
      }
      if (!product.isActive || !product.isRegoOpen) {
        return 'Closed';
      }
      if (isMembershipRequired && !isRegistered) {
        return 'Required';
      }
      if (isRegistered && isPayAfter) {
        return 'Pay Now';
      }
      if (product.type === 'indv-to-team') {
        return 'Join';
      }
      return 'Register';
    },
    handleCardClicked(product) {
      // const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullSlot(product);

      if (isRegistered && !isPayAfter) {
        this.$notify({
          title: 'Already Registered',
          message: 'You are already registered for this product.',
          type: 'success',
          duration: 5000,
        });
        return;
      }
      // console.log('canJoinWaitingList', product.isWaitlistOpen, !isRegistered, !isNotEligible, product.isRegoOpen);
      if (!isEligible) {
        this.$notify({
          title: 'Ineligible',
          message: 'You are not eligible to register for this product.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (!product.isActive || !product.isRegoOpen) {
        this.$notify({
          title: 'Registration Closed',
          message: 'Registration for this product is closed. Please contact your administrator.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      // if (isMembershipRequired && !isRegistered) {
      //   this.$message.error('You must be a member to register for this product');
      //   return;
      // }

      if (fullSlot) {
        this.$notify({
          title: 'Full',
          message: 'This product is full.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (product.type === 'indv-to-team') {
        if (this.filteredTeams(product).length > 0) {
        // You might want to show some modal or UI component here for the user to choose a team
        // Example:
          this.tempProduct = product;
          this.showTeamSelectIndvToTeam = true;
        } else {
          this.$notify({
            title: 'No Teams Available',
            message: 'There are no teams available for this product.',
            type: 'warning',
            duration: 5000,
          });
        }
      } else if (product.type === 'entity') {
      // Similar to the above, you might want to show some modal or UI component here for the user to choose an entity
      // Example:
      // this.showEntitySelectionModal(product);
      } else {
      // This is for the default case where it's just a button.
      // Checking the conditions before actually registering
        // eslint-disable-next-line no-lonely-if
        if (!(this.checkRegistered(product._id) && !this.checkPayAfter(product._id))
          && !this.checkFullSlot(product)
          && this.isEligible(product)) {
          this.register(product._id);
        } else {
        // You can also add a feedback mechanism here for why the user cannot register
          this.$notify({
            title: 'Cannot Register',
            message: 'You cannot register for this product.',
            type: 'warning',
            duration: 5000,
          });
        }
      }
    },
    searchByTag(tag) {
      // start search for events
      this.$emit('searchByTag', tag);
    },
    expandAllProducts() {
      const allKeys = this.groupedByRegistrationType.map((item) => item.key);
      this.activeTabNames = allKeys;
      this.isAllExpanded = true;
      this.$forceUpdate();
    },
    collapseAllProducts() {
      this.activeTabNames = [];
      this.isAllExpanded = false;
      this.$forceUpdate();
    },
    async createNewTeam() {
      // const customEntity = {
      //   _id: this.selectedRego.orgtree[this.selectedRego.entityType]._id,
      //   name: this.selectedRego.orgtree[this.selectedRego.entityType].name
      // };
      // // const foundEntity = this.$store.getters['national/getEntity'];
      // // if (foundEntity && foundEntity._id && foundEntity.name !== '') {
      // //   customEntity = {
      // //     _id: foundEntity._id,
      // //     name: foundEntity.name,
      // //     level: foundEntity.level
      // //   };
      // // }
      // const searchResult = await this.$http.post('/assemble/api/v1/portal/registrations/new-search/20/1', {
      //   criteria: '',
      //   filters: {
      //     membershipType: 'entity-team',
      //     entityType: 'membership'
      //   },
      //   customEntity
      // });
      // const registration = searchResult.data.data.result[0];
      // let teamProduct = [];
      // // return error if no registration found
      // if (!registration) {
      //   this.$message.error(`No entity membership is found for ${customEntity.name}, please contact your administrator`);
      //   return;
      // } if (registration) {
      //   // filter out the team product
      //   teamProduct = registration.products.filter((p) => _.some(p.entityTypeList, { type: 'team' }));
      //   if (teamProduct.length === 0) {
      //     this.$message.error(`No team product is found for ${customEntity.name}, please contact your administrator`);
      //     return;
      //   }
      // }

      const regoObj = this.generateRegoObject(this.selectedProductArr);
      this.startRegistration(regoObj);
    },
    checkTeamRegistered(team) {
      const foundTeam = _.get(this, 'selectedRego.teams', []).find((t) => t._id === team._id);
      return !!foundTeam;
    },

    registerTeam(row) {
      const regoObj = this.generateRegoObject(this.selectedProductArr, null, null, row);
      this.startRegistration(regoObj);
    },
    registerEntity(row) {
      const { entityId, productId } = this.selectedEntity;
      const filteredProducts = this.selectedRego.product.filter((p) => p._id === productId);
      const regoObj = this.generateRegoObject(filteredProducts, null, entityId, null, null, row);
      this.startRegistration(regoObj);
    },
    getOrgtree(row) {
      if (!row.orgtree) return;

      const { orgtree } = row;
      // display all keys from orgTree object
      const orgTreeKeys = Object.keys(orgtree);
      const orgTreeValues = Object.values(orgtree);
      const orgTreeArray = [];
      orgTreeKeys.forEach((key, index) => {
        orgTreeArray.push(`${_.capitalize(key)}: ${orgTreeValues[index].name}`);
      });
      // return each key value pair in a new line
      // eslint-disable-next-line consistent-return
      return orgTreeArray.join(' |  ');
    },
    async searchTeam() {
      this.$store.commit('loading', true, 'Loading teams...');
      // this.$store.commit('loadingText', 'Loading teams...');
      const res = await this.$http.post('/assemble/api/v1/portal/teams/search-entity', {
        teamKeyword: this.teamKeyword,
      });
      this.$store.commit('loading', false);

      const resTeam = res.data.data;
      // get user ID
      const userId = this.$store.getters['user/userId'];
      // sort by user's team first
      const userTeams = resTeam.filter((t) => t.createdBy.length && t.createdBy[0]._id === userId);
      // add flag to indicate user's team
      userTeams.forEach((t) => {
        // eslint-disable-next-line no-param-reassign
        t.isMyTeam = true;
      });
      if (this.teamKeyword === '') {
        this.allTeams = userTeams;
      } else {
        const otherTeams = resTeam.filter((t) => !t.createdBy.length || t.createdBy[0]._id !== userId);
        this.allTeams = userTeams.concat(otherTeams);
      }
    },
    async searchEntity() {
      const { entityType } = this.selectedEntity;
      this.$store.commit('loading', true, 'Loading entities...');
      // this.$store.commit('loadingText', 'Loading teams...');
      const res = await this.$http.post(`/assemble/api/v1/portal/${entityType}/search-entity`, {
        teamKeyword: this.teamKeyword,
      });
      this.$store.commit('loading', false);

      const resTeam = res.data.data;
      // get user ID
      const userId = this.$store.getters['user/userId'];
      // sort by user's team first
      const userTeams = resTeam.filter((t) => t.createdBy.length && t.createdBy[0]._id === userId);
      // add flag to indicate user's team
      userTeams.forEach((t) => {
        // eslint-disable-next-line no-param-reassign
        t.isMyTeam = true;
      });
      const otherTeams = resTeam.filter((t) => !t.createdBy.length || t.createdBy[0]._id !== userId);

      this.allEntities = userTeams.concat(otherTeams);
    },
    calculateAge(dob) {
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      return age;
    },
    async joinWaitlist(productId) {
      const eventId = this.selectedRego._id;
      const entityType = this.selectedRego.registrationType;
      this.$emit('joinWaitList', productId, eventId, entityType);
    },

    checkIsWaitlistOpen(product) {
      return product.isWaitlistOpen && !this.checkRegistered(product._id) && this.isEligible(product);
    },
    checkFullSlot(product) {
      // get items in the cart
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;
      const foundProduct = this.selectedRego.product.find((p) => p._id === product._id);
      const isNoMax = _.get(this, 'selectedRego.noMax');
      if (!foundProduct) return false;
      if (foundProduct.type === 'team' && !isNoMax) {
        const numOfTeams = _.get(this, 'selectedRego.teams', []).length + numberOfSameProduct;
        const maxNoTeams = _.get(this, 'selectedRego.maxNoTeams');
        if (numOfTeams !== 0 && maxNoTeams !== 0 && numOfTeams >= maxNoTeams) {
          return true;
        }
      }
      if (foundProduct.type === 'indv-to-team' && !isNoMax) {
        const regos = _.get(this, 'selectedRego.registrations', []);
        const maxNoIndvTeam = _.get(this, 'selectedRego.maxNoIndvTeam');
        const teamCounts = _.countBy(regos, (r) => (r.productType === 'indv-to-team' ? r.teamId : null));
        console.log({
          regos, maxNoIndvTeam,
        });
        console.log('teamCounts', teamCounts);

        // Find if any team has fewer registrations than maxNoIndvTeam
        const teamsBelowMaxLimit = _.pickBy(teamCounts, (count) => count < maxNoIndvTeam);

        // If there are no teams below the max limit, then the product is full
        if (_.isEmpty(teamsBelowMaxLimit) && teamCounts > 0) {
          return true;
        }
      }
      if (foundProduct.type === 'indv' && !isNoMax) {
        const regos = _.get(this, 'selectedRego.registrations', []);
        const maxProductRego = _.get(foundProduct, 'maxRego', 0);
        const noOfIndv = _.filter(regos, (r) => r.productType === 'indv').length + numberOfSameProduct;
        const maxNoIndv = _.get(this, 'selectedRego.maxNoIndividuals');
        // console.log('maxProdcut Rego', maxProductRego);
        // console.log('noOfIndv', noOfIndv);
        if (noOfIndv !== 0 && maxNoIndv !== 0 && noOfIndv >= maxNoIndv) {
          return true;
        }
        if (maxProductRego !== 0 && noOfIndv >= maxProductRego) {
          // console.log('full slot');
          return true;
        }
      }
      return false;
    },
    checkPayAfter(productId) {
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        // console.log('found', found);
        // return true and the found membership
        if (found[0].payAfter && found[0].payAfterMeta.fullyPaid === false) {
          return true;
        }
      }
      return false;
    },
    isMembershipRequired(product) {
      if (product.type === 'team') return false;
      if (product.isMembershipRequired) {
        const foundMemberships = product.membershipProductsRequired
          .reduce((updatedMembership, pr) => {
            let foundRequiredMS = [];
            if (_.get(pr, 'products.tags') && pr.products.tags.length) {
              const tagArray = pr.products.tags;
              foundRequiredMS = this.memberMembership
                .filter((m) => (_.get(m, 'regoEntity.products.tags', []).length === tagArray.length)
                    && _.get(m, 'regoEntity.products.tags', []).length
                    && m.regoEntity.products.tags.every((tag, index) => tag._id === tagArray[index]._id)
                    && pr._id === m.entityId && pr.products.type === m.productType && pr.products.memberType === m.memberType && m.expired !== true);
            } else {
              foundRequiredMS = this.memberMembership
                .filter((m) => product.membershipProductsRequired.some((p) => p._id === m.entityId
                    && p.products.type === m.productType
                    && p.products.memberType === m.memberType
                    && m.expired !== true));
            }
            return updatedMembership.concat(foundRequiredMS);
          }, []);

        if (!foundMemberships.length) {
          return true;
        }
      }
      return false;
    },
    checkIndvTeamRegistered(product, teamId) {
      console.log('checkIndvTeamRegistered', product, teamId);
      const foundIndvTeamRegistration = this.memberMembership
        .find((m) => _.get(m, 'regoEntity.products._id') === product._id
          && m.expired !== true
          && m.team._id === teamId);
      if (foundIndvTeamRegistration) {
        return true;
      }
      return false;
    },
    async requestAccess() {
      const userId = this.$store.getters['user/userId'];
      const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/request-password', {
        userId,
        productId: this.selectedProduct._id
      });
      if (res.data.data) this.$message.success('Request sent successfully!');
    },
    async authProduct() {
      const { password } = this.product;

      this.$refs.productPassForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/auth', {
              password,
              productId: this.selectedProduct._id
            });
            if (res.data.data) {
              const productArr = [this.selectedProduct];
              const regoObj = this.generateRegoObject(productArr);
              this.startRegistration(regoObj);
              return true;
            }
            this.errorMessage = 'Incorrect password';
            return false;
          } catch (error) {
            // this.$message.error('Invalid password');
            this.errorMessage = 'Invalid password';
            console.log(error);
          }
        }
        return false;
      });
    },
    checkProductVisibility(product) {
      if (this.privateProps.entityId && this.privateProps.productId) return true;
      if (_.get(product, 'isPrivate')) {
        if (product.isVisible !== undefined) {
          if (product.isVisible) return true;
          return false;
        }
      }
      return true;
    },
    checkRegistered(productId) {
      console.log('selectedRego', this.selectedRego);
      // console.log('checkRegistered', productId);
      // console.log('this.memberMembership', this.memberMembership);
      const product = this.selectedRego.product.find((p) => p._id === productId);
      const multipleRegoAllowed = this.$store.getters['national/getMultipleRegoAllowed'];
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        if (multipleRegoAllowed && product.type === 'indv-to-team') {
          return false;
        }
        // return true and the found membership
        return true;
      }

      return false;
    },
    isEligible(product) {
      if (this.selectedMember) {
        // find the registration product based on the productid
        // const foundProduct = this.localRegistration.product.find((p) => p._id === productId);
        if (product) {
          // check gender of the product  and calculate the age of the member and conpare with the age range of the product
          const {
            gender, ageFrom, ageTo,
          } = product;
          const { dob, gender: memberGender } = this.selectedMember.profile;
          const age = this.calculateAge(dob);
          if (ageFrom <= age && ageTo >= age && (memberGender === gender || gender === 'All' || !gender || (gender === 'Other' && (memberGender !== 'Male' && memberGender !== 'Female')))) {
            return true;
          }
          return false;
        }
      }
      return true;
    },
    isProductRegoActive(product) {
      return product.isActive;
    },
    getRegoLogo(rego) {
      const regoLogo = _.get(rego, 'meta.imgUrl', this.defaultRegoLogo);
      console.log('regoLogo', regoLogo);
      return `${regoLogo}?v=${moment().valueOf()}`;
    },
    isExpired(date) {
      if (date) {
        if (date >= +moment()) return false;
        return true;
      }
      return false;
    },
    handleTeamSelected(selected) {
      const { teamId, productId } = selected;
      const filteredProducts = this.selectedRego.product.filter((p) => p._id === productId);
      const regoObj = this.generateRegoObject(filteredProducts, teamId);
      this.startRegistration(regoObj);
    },
    handleTeamSelectedMethod(row) {
      const filteredProducts = this.selectedRego.product.filter((p) => p._id === this.tempProduct._id);
      const regoObj = this.generateRegoObject(filteredProducts, row._id);
      this.startRegistration(regoObj);
      this.showTeamSelectIndvToTeam = false;
    },
    handleEntitySelected(selected) {
      console.log('selected', selected);
      const { entityId, productId, entityType } = selected;
      this.selectedEntity = selected;
      const filteredProducts = this.selectedRego.product.filter((p) => p._id === productId);
      console.log('filteredProducts', filteredProducts, entityId, productId);
      console.log('localRegistration', this.selectedRego);
      if (entityType === 'team') {
        const regoObj = this.generateRegoObject(filteredProducts, null, entityId);
        console.log('regoObjEntity', regoObj);
        this.startRegistration(regoObj);
      } else {
        this.searchEntity(entityType);
        this.showEntitySelect = true;
      }
    },
    createNewEntity() {
      const { entityId, productId } = this.selectedEntity;
      const filteredProducts = this.selectedRego.product.filter((p) => p._id === productId);
      const regoObj = this.generateRegoObject(filteredProducts, null, entityId);
      this.startRegistration(regoObj);
    },
    generateRegoObject(filteredProducts, teamId, OrgId, team, customRego, entity) {
      const {
        acceptActiveKids, description, endDate, entityId, entityType, isRegoOpen, meta, registrationType, name, discounts,
        multipleRegoDiscounts, orgtree, regoEndDate, regoStartDate, saleableItems, additionalQs, startDate, teams, _id, isClubMembership, isRenewable, requiresApproval
      } = customRego || this.selectedRego;
      const filteredAdditionalQs = additionalQs.filter((q) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive;
        }
        return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive && _.includes(q.memberTypes, filteredProducts[0].memberType);
      });
      const filteredSaleableItems = saleableItems.filter((si) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive;
        }
        return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive && _.includes(si.memberTypes, filteredProducts[0].memberType);
      });
      console.log('filteredSaleableItems', filteredSaleableItems);
      console.log('filteredAdditionalQs', filteredAdditionalQs);
      const regoObj = {
        acceptActiveKids,
        name,
        registrationType,
        isClubMembership,
        isRenewable,
        description,
        endDate,
        entityId,
        entityType,
        isRegoOpen,
        meta,
        discounts,
        multipleRegoDiscounts,
        orgtree,
        products: filteredProducts,
        regoEndDate,
        regoStartDate,
        // filter saleable Items with matching product type and memberType and isActive
        saleableItems: filteredSaleableItems,
        additionalQs: filteredAdditionalQs,
        startDate,
        teams,
        _id,
        productType: filteredProducts[0].type,
        tags: filteredProducts[0].tags,
        requiresApproval
      };
      if (filteredProducts[0].type !== 'team' || filteredProducts[0].type !== 'entity') {
        _.assign(regoObj, { memberType: filteredProducts[0].memberType });
      }
      if (teamId) {
        _.assign(regoObj, { selectedTeam: teamId });
      }
      if (OrgId) {
        _.assign(regoObj, { selectedEntity: OrgId });
      }
      if (team && team._id) {
        _.assign(regoObj, { team });
      }
      if (entity && entity._id) {
        _.assign(regoObj, { entity });
      }
      console.log('regoObj', regoObj);
      this.$store.commit('cart/setPendingRegistration', this.selectedRego._id);
      return regoObj;
    },
    filteredTeams(product) {
      const { teams } = this.selectedRego;
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;
      // filter teams that has the same tags as the product
      if (teams && teams.length) {
        const filteredTeams = teams.filter((team) => {
          const teamTags = team && team.tags && team.tags.length ? team.tags.map((tag) => tag._id) : [];
          const productTags = product.tags && product.tags.length ? product.tags.map((tag) => tag._id) : [];
          return _.difference(teamTags, productTags).length === 0;
        });
        _.forEach(filteredTeams, (team) => {
          const indvTeamRegos = _.filter(this.selectedRego.registrations, (r) => r.teamId === team._id && r.productType === 'indv-to-team');
          const maxNoIndvTeam = _.get(this, 'selectedRego.maxNoIndvTeam');
          if (maxNoIndvTeam !== 0 && indvTeamRegos.length + numberOfSameProduct >= maxNoIndvTeam) {
            _.assign(team, { isFull: true });
          }
        });
        console.log('team', filteredTeams);
        return filteredTeams;
      }
      console.log('no teams found');
      return [];
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    dateFormatter(timestamp) {
      // format dd/mmm/yyyy
      return moment(timestamp).format('DD MMM YYYY');
    },
    priceFormatted(price) {
      // price currently in cents
      return `$${(price / 100).toFixed(2)}`;
    },
    mobilePriceFormatted(price) {
      // price currently in cents
      return `$${(price / 100).toFixed(2)}`;
    },
    tagsFormatted(tags) {
      // tags is an array containing objects
      return tags.map((tag) => tag.name).join(', ');
    },
    typeFormatter(type) {
      if (type === 'indv') return 'Become a member';
      if (type === 'indv-to-team') return 'Join a team';
      if (type === 'team') return 'Register a team';
      return '';
    },
    async register(productId) {
      // find product in localRegistration
      // filter out other products from the product array
      console.log('localRegistration at featued', this.selectedRego);

      const isPayAfter = this.checkPayAfter(productId);
      if (isPayAfter) {
        const rego = this.memberMembership
          .find((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);

        this.$router.push({ name: 'partial-payment', params: { rego } });
        return;
      }
      const filteredProducts = this.selectedRego.product.filter((p) => p._id === productId);
      this.selectedProductArr = filteredProducts;
      console.log('filteredProducts', filteredProducts);
      if (filteredProducts.length) {
        [this.selectedProduct] = filteredProducts;
        if (_.get(filteredProducts, '[0].isPrivate')) {
          if (this.privateProps.password) {
            try {
              const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/password-decrypt', {
                productId: filteredProducts[0]._id,
                password: this.privateProps.password
              });
              this.product.password = res.data.data;
              const auth = await this.$http.post('/assemble/api/v1/portal/registrations/product/auth', {
                password: this.product.password,
                productId: filteredProducts[0]._id
              });
              if (auth.data.data) {
                const regoObj = this.generateRegoObject(filteredProducts);
                this.startRegistration(regoObj);
              }
            } catch (e) {
              console.log(e);
              this.showAuthProduct = true;
            }
          }
          this.showAuthProduct = true;
        } else if (filteredProducts[0].type === 'team') {
          this.searchTeam();
          this.showTeamSelect = true;
        } else {
          const regoObj = this.generateRegoObject(filteredProducts);
          console.log('startRegistration', regoObj);
          this.startRegistration(regoObj);
        }
      }
      // replace product array with filteredProducts
      // const regoObj = this.generateRegoObject(filteredProducts);
      // this.startRegistration(regoObj);
    },
    handleEventRegsiterClicked() {
      // emit event to parent
      this.$emit('event-register-clicked', this.selectedRego._id);
    },
    handleShowMoreDetails(productId) {
      const productIndex = this.selectedRego.product.findIndex((p) => p._id === productId);
      this.selectedRego.product[productIndex].showMoreDetails = !this.selectedRego.product[productIndex].showMoreDetails;
      this.key += 1;
    },

    checkEligible(product) {
      if (this.selectedMember) {
        // find the registration product based on the productid
        // const foundProduct = this.localRegistration.product.find((p) => p._id === productId);
        if (product) {
          // check gender of the product  and calculate the age of the member and conpare with the age range of the product
          const { gender, ageFrom, ageTo } = product;
          const { dob, gender: memberGender } = this.selectedMember.profile;
          const age = this.calculateAge(dob);
          if ((ageFrom <= age <= ageTo) && (memberGender === gender || gender === 'All' || !gender || (gender === 'Other' && (memberGender !== 'Male' && memberGender !== 'Female')))) {
            return false;
          }
          return true;
        }
      }
      return false;
    },

    checkFullTeamSlot(product) {
      const foundProduct = this.selectedRego.product.find((p) => p._id === product._id);
      if (!foundProduct) return false;
      if (foundProduct.type === 'team') {
        const numOfTeams = _.get(this, 'selectedRego.teams', []).length;
        const maxNoTeams = _.get(this, 'selectedRego.maxNoTeams', 0);
        return numOfTeams >= maxNoTeams;
      }
      return false;
    },

    openProductListModal(regoEntity) {
      this.selectedRego = regoEntity;
      this.selectedRego.type = 'addon';
      this.productListModal = true;

      // Add scroll listener for mobile sticky header
      if (this.windowWidth <= 1024) {
        this.$nextTick(() => {
          document.addEventListener('scroll', this.handleScroll, { passive: true });
          this.handleScroll(); // Initial check
        });
      }
    },

    // handleScroll() {
    //   if (!this.productListModal || this.windowWidth > 1024) return;

    //   clearTimeout(this.scrollTimeout);

    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   const dialogElement = document.querySelector('.full-width-dialog');

    //   if (dialogElement) {
    //     const dialogRect = dialogElement.getBoundingClientRect();
    //     const dialogTop = dialogRect.top + scrollTop;

    //     // Show sticky header when scrolling past the dialog start and dialog is visible
    //     if (scrollTop > dialogTop && dialogRect.top < 0) {
    //       this.showStickyHeader = true;
    //     } else {
    //       this.showStickyHeader = false;
    //     }
    //   }
    // },

    removeScrollListener() {
      document.removeEventListener('scroll', this.handleScroll);
      this.showStickyHeader = false;
    },

    handleEventClicked(registration) {
      this.$emit('event-register-clicked', registration);
    },

    handleResize() {
      // get window width
      const width = window.innerWidth;
      this.windowWidth = width;
      // get element with class name featured-container
      const featuredContainer = document.querySelector('.featured-container');

      if (width < 480) {
        // set atrribute style to featured-container
        featuredContainer.setAttribute('style', 'max-width: 400px');
      } else if (width <= 992) {
        featuredContainer.setAttribute('style', 'max-width: 768px');
      } else {
        featuredContainer.setAttribute('style', 'max-width: 992px');
      }
    },

    async startRegistration(rego) {
      console.log('start registration', rego);
      this.formattedRego = rego;
      if (rego.productType === 'indv-to-team' && rego.teams && !rego.selectedTeam) { return this.$message.error('Select a team to register.'); }
      if (rego.productType === 'entity' && !rego.selectedEntity) {
        return this.$message.error('Select an entity level to register.');
      }
      const showAlert = () => {
        if (this.selectedRego.requiresApproval) {
          if (this.selectedRego.newMembersOnly) {
            let foundMembership;
            if (this.selectedRego.newMembersThisEntityOnly) {
              // Check for memberships from the same parent entity
              foundMembership = this.memberMembership.find((m) => {
                if (m.entityType === 'membership' && m.membership && m.membership[0]) {
                  const membership = m.membership[0];
                  return membership.entityType === this.selectedRego.entityType
                         && membership.entityId === this.selectedRego.entityId;
                }
                return false;
              });
            } else {
              // Original logic: check for any active membership
              foundMembership = this.memberMembership.find((m) => m.entityType === 'membership');
            }
            if (foundMembership) {
              return false;
            }
          }
          // Check if member is renewing - don't show alert for renewals
          const product = rego.products[0];
          const isRenewing = this.memberMembership.find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.isRenewable);
          if (isRenewing) {
            return false;
          }
          return true;
        }
        return false;
      };

      if (showAlert()) {
        const activeMem = this.$store.getters['user/activeMember'];

        try {
          await this.$confirm(
            `<div style="text-align: left; line-height: 1.5;">
              <p style="margin-bottom: 10px;">Dear ${_.get(activeMem, 'profile.firstName', '')},</p>
              <p style="margin-bottom: 10px;">This registration is not considered 'Approved' until your administrator has 'Approved' this registration.</p>
              <p style="margin-bottom: 10px;">Once an approval or decline has occurred you will be notified via email.</p>
              <p style="margin-bottom: 0;">You can also view the status of this registration via registration history in the portal.</p>
            </div>`,
            'Registration Approval Required',
            {
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
              dangerouslyUseHTMLString: true,
            }
          );
        } catch (error) {
          // User clicked cancel
          return false;
        }
      }
      if (rego.productType === 'entity') {
        const pathName = this.hasCustomEntity ? 'custom-membership-register-entity' : 'membership-register-entity';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedMembership: rego },
        });
      } else if (rego.productType === 'team') {
        const pathName = this.hasCustomEntity ? 'custom-event-register-team' : 'event-register-team';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedEvent: rego },
        });
      } else if (this.memberId && _.get(this.member, 'profile.dob')) {
        console.log('this.member', this.member);
        // if user selected member in dashboard to register
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(this.member.profile.dob, endOfYear);
        // const validProduct = _.find(rego.products, (p) => age >= p.ageFrom && age <= p.ageTo && (p.gender === this.member.profile.gender || p.gender === 'All'));
        // check if member is eligible to register
        // check if age is in range
        const product = rego.products[0];
        const validAge = product.ageFrom <= age && product.ageTo >= age;
        if (!validAge) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the Age range registration criteria');
        }

        const validGender = product.gender === this.member.profile.gender || product.gender === 'All' || (product.gender === 'Other' && (this.member.profile.gender !== 'Male' || this.member.profile.gender !== 'Female'));
        if (!validGender) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the Gender registration criteria');
        }
        // if (!validProduct) {
        //   console.log('validProduct', validProduct);
        //   return this.$message.error('Unfortunately the member you selected doesn\'t meet the registration criteria');
        // }
        if (rego.products.find((p) => p.isMembershipRequired)) {
          const currMemberMembership = this.$store.getters['user/getActiveMemberRegos'];
          const foundMemberships = rego.products[0].membershipProductsRequired
            .reduce((updatedMembership, pr) => {
              let foundRequiredMS = [];
              if (pr.products.tags && pr.products.tags.length) {
                const tagArray = pr.products.tags;
                foundRequiredMS = currMemberMembership
                  .filter((m) => (_.get(m, 'regoEntity.products.tags', []).length === tagArray.length)
                    && _.get(m, 'regoEntity.products.tags', []).length
                    && m.regoEntity.products.tags.every((tag, index) => tag._id === tagArray[index]._id)
                    && pr._id === m.entityId && pr.products.type === m.productType && pr.products.memberType === m.memberType && m.expired !== true);
              } else {
                foundRequiredMS = currMemberMembership
                  .filter((m) => rego.products[0].membershipProductsRequired.some((p) => p._id === m.entityId
                    && p.products.type === m.productType
                    && p.products.memberType === m.memberType
                    && m.expired !== true));
              }
              return updatedMembership.concat(foundRequiredMS);
            }, []);

          const pendingRegos = this.$store.getters['cart/registrations'];
          const requiredMembershipInPendingRegos = rego.products[0].membershipProductsRequired.some((requiredProduct) => pendingRegos.some((reg) => reg.product._id === requiredProduct.products._id
            && reg.product.type === requiredProduct.products.type
            && reg.product.memberType === requiredProduct.products.memberType
            && reg.memberId === this.memberId));

          // const membershipIds = _.uniq(_.map(rego.products[0].membershipProductsRequired, '_id'));
          // const productIds = _.uniq(_.map(rego.products[0].membershipProductsRequired, 'products._id'));
          if (!foundMemberships.length && !requiredMembershipInPendingRegos) {
            this.$confirm('Membership is required to join this event/membership. Do you want to register the required membership? ', 'Membership Required', {
              confirmButtonText: 'Get Membership',
              cancelButtonText: 'No',
              type: 'warning',
            }).then(async () => {
              console.log('membershuip required', rego.products[0].membershipProductsRequired);
              this.$store.commit('cart/setPendingRequiredRego', rego);
              this.searchingRequiredMs = true;
              const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
              console.log('pathName', pathName);
              this.$router.push({ name: pathName, params: { membershipRequiredProducts: rego.products[0].membershipProductsRequired } });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: 'Cancelled',
              });
            });
            return false;
            // this.requireMembershipDialog = true;
            // return false;
          }
        }
        if (rego.products.find((p) => p.isAccreditationRequired)) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          // this.$store.commit('loadingText', 'Loading...');
          const accreditationIds = _.map(_.get(rego, 'products[0].accreditationProductsRequired', []), (a) => a._id);
          const outerThis = this;
          this.$http.post('/assemble/api/v1/portal/registrations/member-accreditations', { accreditationIds }) // eslint-disable-next-line
            .then((res) => {
              this.$store.commit('loading', false);
              const accredMemberIds = res.data.data;
              if (!_.includes(accredMemberIds, outerThis.memberId)) {
                this.requireAccreditationDialog = true;
                return;
              }
              outerThis.selectMember(this.memberId);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        } else this.selectMember(this.memberId);
      } else {
        this.selectMemberModalVisible = true;
      }
      return true;
    },
    async getMemberMembership(memberId) {
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${memberId}`);
      return response;
    },

    async selectMember(memberId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      // this.$store.commit('loadingText', 'Loading...');
      this.memberID = memberId;
      // Verify if eventId, memberId and memberType exists
      const registrations = this.$store.getters['cart/registrations'];

      if (this.formattedRego.registrationType === 'event') {
        const {
          _id: entityId, productType, memberType, tags, ageFrom, ageTo
        } = this.formattedRego;

        const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && r.memberType === memberType
                                && _.isEqual(r.tags, tags));
        if (foundRego && productType !== 'indv-to-team') {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        if (foundRego && productType === 'indv-to-team') {
          const currentTeamId = this.formattedRego.selectedTeam;
          const foundTeam = _.find(registrations, (t) => t.team && t.team._id === currentTeamId);
          if (foundTeam) {
            this.$store.commit('loading', false);
            return this.$message.error('Registration for this member has already been added to cart.');
          }
        }

        if (this.formattedRego.productType === 'indv') {
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.formattedRego },
          });
        } else if (this.formattedRego.productType === 'indv-to-team') {
          if (this.formattedRego.teams) {
            const team = this.formattedRego.teams.find((item) => item._id === this.formattedRego.selectedTeam);
            _.assign(this.formattedRego, { team });
            delete this.formattedRego.teams;
            delete this.formattedRego.selectedTeam;
          }
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.formattedRego },
          });
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Registration for this product type is not available yet.');
        }
      } else if (this.formattedRego.registrationType === 'membership') {
        const {
          _id: entityId, productType, memberType, tags, ageFrom, ageTo
        } = this.formattedRego;

        const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && _.isEqual(r.tags, tags)
                                && r.memberType === memberType);
        if (foundRego) {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        // check if member register to club membership before
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        // this.$store.commit('loadingText', 'Loading...');
        if (!this.currentMemberMemberships) {
          const response = await this.getMemberMembership(memberId);
          this.memberMembership = response.data.data;
          this.$store.commit('user/setMemberRegos', this.memberMembership);
        }
        if (this.formattedRego.isClubMembership && this.formattedRego.memberType === 'player' && this.currentMemberMemberships) {
          console.log('isClubMembership', this.formattedRego);
          const foundClubMembership = this.currentMemberMemberships.filter((rego) => rego.isClubMembership && rego.expired !== true && rego.memberType === 'player');
          if (foundClubMembership.length) {
            const registeredMembership = foundClubMembership.find((club) => _.get(club, 'regoEntity.products._id') === _.get(this.formattedRego, 'products[0]._id')
            && club.entityId === this.formattedRego._id
            && club.memberId === memberId);
            if (registeredMembership) {
              this.$store.commit('loading', false);
              return this.$message.error('You have already registered to this club.');
            }
            await this.checkRequestClearances(memberId);
            this.$store.commit('loading', false);
          } else {
            const foundClubMembershipinCart = registrations.find((r) => r.isClubMembership);
            if (foundClubMembershipinCart) return this.$message.error('There is already a club membership in your cart, you can only buy one at a time .');
            this.$store.commit('loading', false);
            const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
            this.$router.push({
              name: pathName,
              params: { criteria: this.criteria, memberId, selectedMembership: this.formattedRego },
            }).catch((error) => {
              if (
                error.name !== 'NavigationDuplicated'
                && !error.message.includes('Avoided redundant navigation to current location')
              ) {
                console.log(error);
              }
            });
          }
        } else {
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedMembership: this.formattedRego },
          }).catch((error) => {
            if (
              error.name !== 'NavigationDuplicated'
                && !error.message.includes('Avoided redundant navigation to current location')
            ) {
              console.log(error);
            }
          });
        }
      }
      return 0;
    },
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      // eslint-disable-next-line no-param-reassign
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    // featureRegistrations() {
    //   this.$nextTick(() => {
    //     this.$refs.carousel.refresh();
    //   });
    // }
    productListModal(newVal) {
      if (!newVal) {
        this.removeScrollListener();
      }
    }
  },

};
</script>

<style lang="scss" scoped>
::v-deep .slick-prev:before{
  color: var(--highlight-color);
}
::v-deep .el-card__body {
  padding: 0;
}
.full-width-dialog {
  margin: 0 !important;
  &.el-dialog__wrapper {
    z-index: 2004 !important; // Adjust this value as needed
  }
}

/* Override Element UI's default dialog styles */
.full-width-dialog .el-dialog {
  margin: 0 !important;
  width: 100% !important;
  max-width: none !important;
}
::v-deep .el-dialog__wrapper {
  // Remove any backdrop filter effects that might be inherited
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding-top: 2em;
    text-align: left;
  }
}
.team-selector{
    width: 100%;
    padding: 0;
}
::v-deep .slick-next:before{
  color: var(--highlight-color)
}
::v-deep .el-dialog{
  max-width: 80%;
  .el-dialog__body{
    padding: 0 20px 20px 20px !important;
  }
}

::v-deep .el-dialog__body{
  flex-direction: column;
}
.featured-container{
  height: 450px !important;
  width: 100%;
  max-width: $md !important;
  padding: 0 0.5rem;
  .featured-heading{
    text-align: center;
  }
    .registration-card-container{
  padding: 32px 24px;
  min-height: 380px;
  background: var(--highlight-color);
  color: var(--text-color-primary);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  min-width: 300px !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12), 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.12);
  }

  .card-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-bottom: 24px;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    .logo-container {
      margin-bottom: 24px;
      display: flex;
      justify-content: center;

      .logo-wrapper {
        width: 80px;
        height: 80px;
        border-radius: 16px;
        background: rgba(255, 255, 255, 0.15);
        border: 2px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 60px;
          height: 60px;
          border-radius: 14px;
          object-fit: contain;
        }
      }
    }

    .event-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 26px;
      color: var(--text-color-primary);
      text-align: center;
      letter-spacing: -0.3px;
      margin-bottom: 8px;
      min-height: 52px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
    }

    .organization-name {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: var(--text-color-primary);
      opacity: 0.8;
      letter-spacing: -0.2px;
      margin-bottom: 12px;
      text-align: center;
      width: 100%;
    }

    .event-duration {
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: var(--text-color-primary);
      opacity: 0.7;
      letter-spacing: -0.1px;
      margin-bottom: 24px;
      padding: 6px 12px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      text-align: center;
      width: fit-content;
      align-self: center;
    }
  }

  .card-footer {
    display: flex;
    width: 100%;
    margin-top: auto;

    .register-button {
      width: 100%;
      height: 48px;
      font-weight: 600;
      font-size: 16px;
      border-radius: 8px;
      transition: all 0.2s ease;
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: var(--text-color-primary);

      &:hover {
        transform: translateY(-1px);
        background: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.5);
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
      }

      &:active {
        transform: translateY(0);
        background: rgba(255, 255, 255, 0.15);
      }
    }
  }
}
}
::v-deep .el-collapse-item__header {
  background: $secondaryLight;
  padding: 0 1rem;
  position: relative;
  &::after {
    // highlight line
    content: '';
    position: absolute;
    width: 5px;
    height: 100%;
    background: var(--secondary-color);
    left: 0%;
    top: 0%;
    transform: translate(0%, 0%);

  }
}

::v-deep .el-button--primary{
  width: 100%;
  min-width:9.5rem;
  background-color: var(--secondary-color);
  color: var(--text-color-secondary);
  border-color: var(--secondary-color);
}
::v-deep .el-tag{
  line-height: 20px;
  height: 20px;
  font-size: 12px;
  margin-right: 0.25rem;
  border-color: transparent;
  border-radius: 6px;
}

.products-container{
  // width: 1268px;
  background: #FFFFFF;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
  padding: 25px;
  margin-top: 20px;
  width: 100%;
  .label-headers {
    display: grid;
    grid-template-columns: 8fr 2fr;
    gap: 10px;
    align-items: flex-end !important;
    justify-items: center;
    margin-bottom: 0.5rem;
    padding: 0 1rem;

    .label-header {
      font-weight: 600;
      color: #9f9f9f;
      font-size: 16px;
      line-height: 25px;
      opacity: 0.8;
      margin-right: 10px;
      grid-row-start: 1;
    }
    .description{
      display: flex !important;
      width: 100%;
      font-weight: 300;
      color: #535353;
      font-size: 12px;
      line-height: 20px;
      opacity: 0.7;
      margin-right: 10px;
      grid-row-start: 1;
      align-items: flex-start !important;
      justify-items: flex-start !important;
      font-family: 'BrownStd-Light';
      // max line is 5
      max-height: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;

    }
    .expand-all-button{
      display: flex;
      justify-content: flex-end;
      width: 100%;
      margin-right:1rem
    }
  }

  .product-container{
    display: flex;
    flex-direction: column;
    padding: 10px 0 0 0;
    // border-top: 0.5px solid rgba(0, 0, 0, 0.2);
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
    .product-container-main{
      display: grid;
      grid-template-columns: 7fr 6.5rem 2fr;
      margin: 0 1.2rem;

      &.header {
        h4 {
          color: rgba(60, 60, 60, 0.8);
          font-family: 'BrownStd-Light';
          padding: 0;
          margin: 0;
          font-size: 11px;
        }
      }
      // margin-top: 20px;

      .product-description{
        color: $primary;
        display: grid;
        grid-template-columns: 90px 80px 80px 1fr;
        gap: 1rem;
        align-items: center !important;
        .product-displayName{
        // margin-left: 0 10%;
        // display: flex;
        // align-items: center;
        // opacity: 0.6;
        color: #3c3c3c;
        margin: 0;
        width: 16rem;
        font-style: normal;
        // font-weight: 700;
        // font-size: 1.2rem;
        // display:inline-block;
        // line-height: 2.5rem;
        // ellipsis
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .max-lines {
          /* Set a height for the container */
          height: 3.75rem; /* 5 lines x 0.75rem line height */
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
        }
        .max-lines p {
          margin: 0; /* remove any margin that may be applied to the p tag by default */
          line-height: 0.75rem; /* set the desired line height */
        }
        }
        .membertype-gender{
          display: grid;
          grid-template-columns: 7fr 3fr;
        }

      }

      .tag{
        // background: rgba(196, 196, 196, 0.2);
        border-radius:10px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 25px !important;
        height: 25px;
      }
      .dark-color{
        background: #c4c4c4;
      }
      .memberType{
        width: 100%;
      }
      .gender{
        width: 100%;
      }
      .product-displayName{
        margin-left:0 10% ;
        display: flex;
        align-items: center;
        // opacity: 0.6;
        font-style: normal;
        font-weight: 500;
        // font-size: 1rem;
        display:inline-block;
        // line-height: 2.5rem;
        // ellipsis
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .product-tags{
        align-items: center;
        display: flex;
        span{
          font-family: $fontBold !important;
          font-weight: 700;
          font-size: 15px;
          line-height: 25px;
          letter-spacing: -0.5px;
          color: #303133;
          opacity: 0.6;
        }
        overflow: hidden;
        word-break: break-word !important;
      }
      .product-register{
        font-size: 14px;
        font-weight: 600;
        color: #000000;
        filter: drop-shadow(3px 4px 4px rgba(233, 233, 233, 0.5));
        display: flex;
        justify-content: flex-end;
        .secondary-type{
          background: var(--secondary-color);
          color: var(--text-color-secondary);
          // color: #000;
          &:hover{
            // hover color to higher contrast
            background: var(--secondary-color);
            opacity: 0.8;
            // color: #000;
          }
        }
      }
      .product-price{
        font-style: normal;
        font-weight: 400;
        font-size: 1rem;
        line-height: 25px;
        display: flex;
        align-items: center;
        letter-spacing: -0.5px;
        margin-left: 10px;

        color: #303133;

      }
    }

    .product-tag {
        border-radius:10px;
        // text-align: center;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        font-weight: 400;
        font-size: 11px;
        font-family:'BrownStd-Light';
        line-height: 25px !important;
        color: #303133;
        /* line-height: 25px !important; */
        height: 25px;
        color: #606060;
        padding: 0.5rem;
        // background: #f9f9f9;
        display: inline-flex;
        align-items: center;
        // .tag{
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }

        // }
      }
    .product-container-expand{
      display: flex;
      // gap: 20px;
      // grid-template-columns: 2.9fr 7.1fr;

      margin-top: 20px;
      // .title{
      //   width: 5rem;
      //   text-align: center;
      //   font-size: 1rem;
      // }
      .product-tags{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .tag{
          // background: rgba(196, 196, 196, 0.2);
          border-radius: 50px;
          font-weight: 400;
        }
      }

    }
    .desktop-tag-list{
      margin-left: 18rem;
    }

  }

}
.products-container-mobile{
  // width: 1268px;
  background: #FFFFFF;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
  padding: 10px;
  margin-top: 20px;
  .label-headers {
    display: grid;
    grid-template-columns: 8fr 2fr;
    gap: 10px;
    align-items: flex-end !important;
    justify-items: center;
    margin-bottom: 0.5rem;
    padding: 0 1rem;

    .label-header {
      font-weight: 600;
      color: #9f9f9f;
      font-size: 16px;
      line-height: 25px;
      opacity: 0.8;
      margin-right: 10px;
      grid-row-start: 1;
    }
    .description{
      display: flex !important;
      width: 100%;
      font-weight: 300;
      color: #535353;
      font-size: 12px;
      line-height: 20px;
      opacity: 0.7;
      margin-right: 10px;
      grid-row-start: 1;
      align-items: flex-start !important;
      justify-items: flex-start !important;
      font-family: 'BrownStd-Light';
      // max line is 5
      max-height: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;

    }
    .expand-all-button{
      display: flex;
      justify-content: flex-end;
      width: 100%;
      margin-right:1rem
    }
  }

  .product-container{
    display: flex;
    flex-direction: column;
    padding: 10px 0 0 0;
    // border-top: 0.5px solid rgba(0, 0, 0, 0.2);
    // border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);

    .product-tag {
        border-radius:10px;
        // text-align: center;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        font-weight: 400;
        font-size: 11px;
        font-family:'BrownStd-Light';
        line-height: 25px !important;
        color: #303133;
        /* line-height: 25px !important; */
        height: 25px;
        color: #606060;
        padding: 0.5rem;
        // background: #f9f9f9;
        display: inline-flex;
        align-items: center;
        // .tag{
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }

        // }
      }
    .product-container-main-mobile{
      .product-description{
        display: flex;
        // justify-content: space-between;
        margin: 11px 0 0 0;
        padding: 0 0.5rem;

        .tag{
        // background: rgba(196, 196, 196, 0.2);
        border-radius: 50px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 1.1rem;
        line-height: 2rem;
        }
        .dark-color{
          background: #c4c4c4;
        }
        .member-type{
          flex-basis: 50%;
        }
        .gender{
          flex-basis: 30%;
        }
        .age{
          flex-basis: 20%;
        }
        .product-displayName{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          opacity: 0.6;
          font-style: normal;
          font-weight: 500;
          font-size: 1rem;
          line-height: 1.8rem;
          // limit line to 5
          .max-lines {
            /* Set a height for the container */
            max-height: 9rem; /* 5 lines x 0.75rem line height */
            overflow: hidden;
            font-style: normal;
            font-weight: 700;
            font-size: 1.2rem;
            line-height: 1.8rem;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
          }
          .max-lines p {
            margin: 0; /* remove any margin that may be applied to the p tag by default */
            line-height: 1.8rem; /* set the desired line height */
          }

        }

        .product-tags{
          align-items: center;
          display: flex;
          span{
            font-family: $fontBold !important;
            font-weight: 700;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: -0.5px;
            color: #303133;
            opacity: 0.6;
          }
          overflow: hidden;
          word-break: break-word !important;
        }
        .product-price{
          font-style: normal;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.8rem;
          display: flex;
          align-items: center;
          letter-spacing: -0.5px;
          color: #303133;
        }
      }
      .grid-style{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
      }
      .product-register{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        // justify-content: flex-end;
        // flex-direction: column;
        .secondary-type-button{
          background: var(--secondary-color);
          color: #000;
          &:hover{
            // hover color to higher contrast
            background: var(--secondary-color);
            opacity: 0.8;
            color: #000;
          }
        }
        .primary-type-button{
          margin: 0;
          // display: flex;
          // border-radius: 50px;
          // text-align: center;
          // align-items: center;
          // justify-content: center;
          // margin-bottom: 10px;
        }
      }
    }
    .product-container-expand{
      display: flex;
      // gap: 20px;
      // grid-template-columns: 2.9fr 7.1fr;

      margin-top: 20px;
      // .title{
      //   width: 5rem;
      //   text-align: center;
      //   font-size: 1rem;
      // }
      .product-tags{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .tag{
          // background: rgba(196, 196, 196, 0.2);
          border-radius: 50px;
          font-weight: 400;
        }
      }

    }
    .desktop-tag-list{
      margin-left: 18rem;
    }

  }

}

/* Sticky Header Styles */
.sticky-event-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2005;
  background: #ffffff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  transform: translateY(-100%);

  &.sticky-visible {
    transform: translateY(0);
  }

  &.sticky-hidden {
    transform: translateY(-100%);
  }
}

.sticky-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  max-width: 100vw;
}

.sticky-event-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.sticky-avatar {
  margin-right: 12px;
  flex-shrink: 0;
}

.sticky-details {
  flex: 1;
  min-width: 0;
}

.sticky-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.sticky-subtitle {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  margin-top: 2px;
}

.sticky-actions {
  flex-shrink: 0;
  margin-left: 12px;
}

/* Enhanced mobile card styling */
@media (max-width: 1024px) {
  .full-width-dialog {
    .el-dialog {
      margin-top: 0 !important;
    }
  }

  .registration-card-container {
    .register-button {
      .el-button {
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
          transition: left 0.5s;
        }

        &:hover::before {
          left: 100%;
        }
      }
    }
  }
}

/* Improved touch targets for mobile */
@media (max-width: 767px) {
  .registration-card-container {
    .register-button .el-button {
      min-height: 44px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .sticky-header-content {
    padding: 10px 14px;
  }

  .sticky-title {
    max-width: 160px;
  }

  .sticky-subtitle {
    max-width: 160px;
  }
}

</style>
